// Developed by Softvative.com
import React, { useState } from 'react';
import { motion } from 'framer-motion';

const PerformanceChart = () => {
    const [activeTab, setActiveTab] = useState('Weekly');

    const tabs = ['Weekly', 'Monthly', 'Quarterly'];

    return (
        <div className="p-6">
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
                    Performance Overview
                </h2>
                <div className="flex space-x-1 bg-gray-100 dark:bg-gray-700 rounded-lg p-1">
                    {tabs.map((tab) => (
                        <button
                            key={tab}
                            onClick={() => setActiveTab(tab)}
                            className={`px-3 py-1 text-sm font-medium rounded-md transition-all ${activeTab === tab
                                    ? 'bg-white dark:bg-gray-600 text-gray-900 dark:text-white shadow-sm'
                                    : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
                                }`}
                        >
                            {tab}
                        </button>
                    ))}
                </div>
            </div>

            <div className="h-64 flex items-center justify-center bg-gray-50 dark:bg-gray-700/50 rounded-lg">
                <div className="text-center">
                    <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full mx-auto mb-4 flex items-center justify-center">
                        <span className="text-white font-bold text-xl">📊</span>
                    </div>
                    <p className="text-gray-600 dark:text-gray-400 mb-2">Performance metrics visualization</p>
                    <p className="text-sm text-gray-500 dark:text-gray-500">
                        Shows MTTR, incident volume, and SLA compliance trends
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PerformanceChart;